module.exports = __webpack_public_path__ + "img/licenzaTop.931ec41b.jpeg";